import React from 'react';
import { activities } from '../data/mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const Activites = () => {
  const categories = ['Terrestre', 'Aquatique','Loisirs'];

  const getActivitiesByCategory = (category) => {
    return activities.filter(act => act.category === category);
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/trottinette_saut.jpg')" }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Activités Fremyc</h1>
          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
            Découvrez les Gorges du Tarn, de la Jonte et les Grands Causses à travers des activités de pleine nature accessibles à tous
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900">Des aventures pour tous les niveaux</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            Fremyc vous propose une grande variété d'activités de pleine nature au cœur du Parc National des Cévennes. Pour tout âge, en famille ou entre amis, trouvez l'activité qui vous correspond.
          </p>
        </div>
      </section>

      {/* Activities by Category */}
      {categories.map((category) => {
        const categoryActivities = getActivitiesByCategory(category);
        if (categoryActivities.length === 0) return null;

        return (
          <section key={category} className="py-16 px-4 odd:bg-gray-50 even:bg-white">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-3xl font-bold mb-12 text-gray-900">
                Activités {category}s
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {categoryActivities.map((activity) => (
                  <Link
                    key={activity.id}
                    to={`/activites/${activity.slug}`}
                    className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                  >
                    <div className="relative h-64 overflow-hidden">
                      <img 
                        src={activity.imageUrl} 
                        alt={activity.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <h3 className="text-2xl font-bold text-white mb-1">{activity.name}</h3>
                        <span className="text-sm text-gray-200">{activity.category}</span>
                      </div>
                    </div>
                    <div className="p-6">
                      <p className="text-gray-700 mb-4 leading-relaxed">{activity.description}</p>
                      <div className="flex items-center gap-2 text-[#afab53] font-semibold group-hover:gap-4 transition-all">
                        <span>En savoir plus</span>
                        <ArrowRight className="w-5 h-5" />
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        );
      })}

      {/* CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-[#afab53] to-[#8a8742]">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Composez votre programme d'activités</h2>
          <p className="text-xl mb-10 text-white/90">
            Combinez plusieurs activités pour créer votre séjour idéal. Notre équipe est à votre disposition pour vous conseiller.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-[#afab53] hover:bg-gray-100 text-lg px-8 py-6">
              Demander un devis
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Activites;